import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-regulatory-event-diary-order-dialog',
  templateUrl: './regulatory-event-diary-order-dialog.component.html',
  styleUrls: ['./regulatory-event-diary-order-dialog.component.scss'],
})
export class RegulatoryEventDiaryOrderDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RegulatoryEventDiaryOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
